import { Component, OnInit } from "@angular/core";
import { ShortLinksService } from "../../../auth/service/short-links.service";
import { AuthenticationService, UserService } from "../../../auth/service";
import { Router } from "@angular/router";
import { UtilsService } from "../../../auth/service/utils.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DocumentsService } from "../../../auth/service/documents.service";
import { environment } from "../../../../environments/environment";
import { ToastrService } from "ngx-toastr";
import { locale as italian } from "../../../i18n/it";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { IShortLink, IShortLinkForm } from "app/auth/models/shortlink";

@Component({
  selector: "app-short-link",
  templateUrl: "./short-link.component.html",
  styleUrls: ["./short-link.component.scss"],
})
export class ShortLinkComponent implements OnInit {
  public contentHeader: IContentHeader;
  public searchKey: string = "";
  public shortLinkList: IShortLink[] = [];
  public filterShortLinkList: IShortLink[] = [];
  public document_id: number = null;
  public employees: any = [];
  public employee: any = "";
  public environment: string;
  public title: string = "";
  public documents_list: any = [];
  public showModalError: boolean = false;

  constructor(
    public _shortLinkService: ShortLinksService,
    public _authenticationService: AuthenticationService,
    private _routerService: Router,
    public _utilService: UtilsService,
    public _modalService: NgbModal,
    public _documentService: DocumentsService,
    public _userService: UserService,
    public toastr: ToastrService,
  ) {
    this._utilService.disableAutoHideLoading();
  }

  async ngOnInit() {
    if (!this._authenticationService.hasCapability("view_shortlink_list")) {
      await this._routerService.navigateByUrl("/dashboard/main");
      return false;
    }
    this.contentHeader = {
      headerTitle: "MENU.SHORTLINKS",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "MENU.MANAGE",
            isLink: true,
            link: "/dashboard/platform-management",
          },
          {
            name: "MENU.SHORTLINKS",
            isLink: false,
          },
        ],
      },
    };
    await this.loadShortLink();
    await this.searchShortLink();
    await this._documentService.getList().then((result: any) => {
      this.documents_list = result;
    });
    await this._userService.getList().then((result: any) => {
      this.employees = result;
    });
    this.environment = environment.SHORTLINK_URL + "/";
    this._utilService.hideLoading();
  }

  async loadShortLink() {
    this.shortLinkList = await this._shortLinkService.getShortLinks();
  }

  async searchShortLink() {
    const key: string = this.searchKey.trim().toLowerCase();
    let filterShortLinkList: IShortLink[] = this.shortLinkList;
    if (key.length > 0) {
      filterShortLinkList = filterShortLinkList.filter((item: IShortLink) => {
        return item?.document?.title?.toLowerCase().includes(key) || item?.user?.complete_name?.toLowerCase().includes(key);
      });
    }
    this.filterShortLinkList = filterShortLinkList;
  }

  async delete(currentShortLink: IShortLink) {
    let deleteText: string = await this._utilService.translate("ALERT.CONFIRM_DELETE_TEXT");
    deleteText += await this._utilService.translate("ALERT.CONFIRM_DELETE_THIS_OBJECT");
    deleteText += ` ${currentShortLink.document.title}`;

    await this._utilService.showSWALDeleteConfirmation({ text: deleteText }).then(async (result) => {
      if (result.value) {
        this._utilService.showLoading();
        await this._shortLinkService
          .deleteShortLink(currentShortLink.id)
          .then(async () => {
            this._utilService.hideLoading();
            await this._utilService.showSWALSuccess({ text: "SUCCESS_DELETE_SHORTLINK" });
            this.filterShortLinkList = this.filterShortLinkList.filter((item) => item.id != currentShortLink.id);
          })
          .catch(async () => {
            this._utilService.hideLoading();
            await this._utilService.showSWALError({ text: "ERROR_DELETE_SHORTLINK" });
          });
      } else if (result.isDismissed) {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({
          title: "ABORTED_TITLE",
          text: "ABORTED_TEXT",
        });
      }
    });
  }

  async add() {
    if (!this.document_id || this.document_id < 1) {
      this.showModalError = true;
      return false;
    }
    let data: IShortLinkForm = {
      document_id: this.document_id,
      original: environment.BASE_URL + "/dashboard/user-document-view/" + this.document_id,
      for_user: this.employee?.hash || null,
      title: this.title,
    };
    await this._utilService.showLoading();
    await this._shortLinkService
      .createShortLink(data)
      .then(async () => {
        this._utilService.hideLoading();
        this._modalService.dismissAll();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_UPLOAD_SHORTLINK" });
        await this.loadShortLink();
        await this.searchShortLink();
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_UPLOAD_SHORTLINK" });
      });
  }

  copy(url: string, id: string) {
    let element = url + id;
    navigator.clipboard.writeText(element).then(() => {
      this.toastr.success(null, italian.data.ALERT.COPY, {
        toastClass: "toast ngx-toastr",
        timeOut: 2000,
      });
    });
  }

  public modalOpen(modalBasic) {
    this.document_id = null;
    this.employee = null;
    this.title = "";
    this._modalService.open(modalBasic, {
      size: "md",
      centered: true,
    });
    this.showModalError = false;
  }

  documentChanged() {
    const doc: any = this.documents_list.find((item: any) => item.id === this.document_id);
    if (doc) {
      this.title = doc.title;
    } else {
      this.title = "";
    }
  }
}
